import { render, staticRenderFns } from "./OutreachMatchTable.vue?vue&type=template&id=137beed2&scoped=true&"
import script from "./OutreachMatchTable.vue?vue&type=script&lang=js&"
export * from "./OutreachMatchTable.vue?vue&type=script&lang=js&"
import style0 from "./OutreachMatchTable.vue?vue&type=style&index=0&id=137beed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137beed2",
  null
  
)

export default component.exports